import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await client.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setIsLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 16, color: 'var(--c-primary)', border: '2px solid var(--c-primary)', borderRadius: 8, width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>@</div>
          <h2 className="auth-title">Check Your Email</h2>
          <p className="auth-subtitle">
            If an account exists with <strong>{email}</strong>, we've sent a password reset link to your inbox.
          </p>
          <p className="auth-subtitle" style={{ fontSize: 13, color: 'var(--c-text-muted)' }}>
            The link will expire in 1 hour.
          </p>
          <button className="btn btn-primary btn-full" onClick={() => navigate('/login')}>
            Back to Log In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 420, margin: '0 auto' }}>
        <div className="auth-logo">
          <img src="/RDF_Logo.svg" alt="RDF" className="auth-logo-img" />
          <span className="auth-logo-text">Retail Derivatives Forum</span>
        </div>
        <h2 className="auth-title">Forgot Your Password?</h2>
        <p className="auth-subtitle">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label className="form-label">Email Address <span className="req">*</span></label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="jane@firm.com"
              autoComplete="email"
              required
            />
          </div>

          <button className="btn btn-primary btn-full" type="submit" disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-switch" style={{ marginTop: 16 }}>
          Remember your password? <span onClick={() => navigate('/login')}>Log In</span>
        </div>
      </div>
    </div>
  );
};
